import api from "../api";

export const menuIndicadorService = {
  listarVisiveis() {
    return api.get("/menus/indicadores");
  },
  destino(codigo) {
    return api.get(`/menus/indicadores/${codigo}/destino`);
  },
  listarAdmin() {
    return api.get("/admin/menus-indicadores");
  },
  get(codigo) {
    return api.get(`/admin/menus-indicadores/${codigo}`);
  },
  criar(payload) {
    return api.post("/admin/menus-indicadores", payload);
  },
  atualizar(codigo, payload) {
    return api.put(`/admin/menus-indicadores/${codigo}`, payload);
  },
  ativar(codigo) {
    return api.put(`/admin/menus-indicadores/${codigo}/ativar`);
  },
  desativar(codigo) {
    return api.put(`/admin/menus-indicadores/${codigo}/desativar`);
  },
  listarGrupos() {
    return api.get("/admin/menus-indicadores/grupos");
  },
  listarPermissoes() {
    return api.get("/admin/menus-indicadores/permissoes");
  },
};
